export default {
    department: 'Department',
    position: '岗位',
    expert: 'expert',
    lecturer: 'lecturer',
    reply: '回复',
    noData: 'No data',
    hour: 'hour ',
    minute: 'score ',
    minutes: 'Min',
    years: '-',
    months: '-',
    day: '',
    download: 'Download',
    ext_code: 'QR code.png',
    lecture: 'Lecturer',
    score_one_star: '1 star',
    score_two_star: '2 star',
    score_three_star: '3 star',
    score_four_star: '4 star',
    score_five_star: '5 star',
    score_no: 'No rates',
    score_do_score: 'I want to rate',
    score_submission: 'Submit to rate',
    share_curriculum: 'Course',
    share_learning_path: 'Learning path',
    share_knowledge: 'Knowledge',
    share_class: 'Class',
    share_investigation_and_research: 'Survey',
    share_micro_class_contest: 'Micro-class competition',
    share_examination: 'Exam',
    share_special: 'Subject',
    share_live_broadcast: 'Live',
    share_discuss: 'Discussion',
    share_content: 'Content',
    share_sharing: 'Share',
    share_the_wechat: 'WeChat',
    share_the_qq_space: 'Qzone',
    share_sina_micro_blog: 'Sina Microblog',
    share_the_question: 'WeSpeak',
    operation_success: 'Operation completed',
    operation: {
        title: 'operation',
        boardName: 'data-board',
        totalVisit: '累计访问用户',
    },
};
